<template>
	<div class="content">
		<div class="header flex-row">
			<div class="step-item flex-column">
				<img src="../../assets/img/icon-categoryed.svg">
				选择预约类型
			</div>
			<div class="step-item flex-column">
				<img src="../../assets/img/icon-infoed.svg">
				填写预约信息
			</div>
			<div class="step-item flex-column">
				<img src="../../assets/img/icon-ordered.svg">
				确认订单结算
			</div>
			<div class="step-item flex-column" style="color: #ffffff;">
				<img src="../../assets/img/icon-settlement.svg">
				订单预约成功
			</div>
		</div>
		<div class="section">
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>订单信息</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="info">
				<div class="data">
					订单编号：SK23031601105888
				</div>
				<div class="data">
					入馆日期：2023-03-17
				</div>
				<div class="data">
					订单状态：待使用
				</div>
				<div class="price">
					订单金额：<span>￥144</span>
				</div>
			</div>
			<div class="table">
				<div class="tableHeader flex-row">
					<div class="item">
						场次
					</div>
					<div class="item">
						姓名
					</div>
					<div class="item">
						证件类型
					</div>
					<div class="item">
						证件号码
					</div>
					<div class="item">
						门票名称
					</div>
					<div class="item">
						票价
					</div>
				</div>
				<div class="tBody">
					<div class="th flex-row" v-for="(item,index) in list" :key="index">
						<div class="data">
							12:30-14:30
						</div>
						<div class="data">
							虹猫
						</div>
						<div class="data">
							身份证
						</div>
						<div class="data">
							244************488
						</div>
						<div class="data">
							普通票
						</div>
						<div class="data">
							￥72
						</div>
					</div>
				</div>
			</div>
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>门票二维码</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="QR">
				<div class="status flex-row">
					<img src='../../assets/img/icon-choose.svg'>
					出票成功！
				</div>
				动态二维码门票将以短信形式发送至您的手机，或直接进入购票小程序-订单详情页查看二维码门票，或直接刷身份证入馆参观。
			</div>
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>支付方式</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="paymode flex-row">
				<div class="item flex-row">
					<img src='../../assets/img/icon-juhe.png'> 聚合支付
				</div>
			</div>
			<div class="tag flex-row">
				<img src="../../assets/img/icon-left.png">
				<span>温馨提示</span>
				<img src="../../assets/img/icon-right.png">
			</div>
			<div class="detail">
				<!-- 此处为富文本内容 -->
			</div>
			<img class="line" src='../../assets/img/icon-line.svg'>
			<div class="btnbox flex-row">
				<div class="backbtn cursorp">
					申请退票
				</div>
				<router-link to="/">
					<div class="prevbtn cursorp">
						返回首页
					</div>
				</router-link>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ReservationSuccess',
		data() {
			return {
				list: [1, 2, 3, 4],
				radio: ''
			}
		},
	}
</script>

<style scoped>
	.content {
		width: 1200px;
		margin: auto;
		background: #FFFFFF;
		box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
		border-radius: 6px;
		padding: 24px;
		box-sizing: border-box;
	}

	.header {
		width: 100%;
		height: 70px;
		background-image: url(../../assets/img/step4.svg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		padding: 0 83px;
		box-sizing: border-box;
		justify-content: space-between;
		margin-bottom: 24px;
	}

	.header .step-item {
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #BB2916;
	}

	.header .step-item img {
		width: 26px;
		height: 26px;
		margin-bottom: 6px;
	}

	.header .step-item img:first-child {
		width: 30px;
		height: 24px;
	}

	.header .step-item img:last-child {
		width: 26px;
		height: 24px;
	}

	.section {
		width: 100%;
	}

	.section .info {
		width: 1007px;
		margin-left: 60px;
		margin-bottom: 8px;
		position: relative;
	}

	.section .info .data {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 20px;
	}

	.section .info .price {
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		position: absolute;
		bottom: 0;
		right: 0px;
	}

	.info .price span {
		font-size: 28px;
		color: #37695C;
	}

	.section .table {
		width: 1007px;
		padding: 0 60px;
		box-sizing: border-box;
	}

	.table .tableHeader {
		width: 1007px;
		height: 64px;
		border-radius: 6px 6px 0px 0px;
		background-image: url('../../assets/img/tableBG.svg');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		justify-content: space-between;
	}

	.table .tableHeader .item {
		font-size: 16px;
		font-family: PingFang SC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		width: 167px;
		text-align: center;
	}

	.table .tBody {
		width: 1007px;
		border: 1px solid #F1F1F1;
	}

	.table .tBody .th {
		width: 100%;
		height: 63px;
		justify-content: space-between;
		border-bottom: 1px solid #F1F1F1;
	}

	.table .tBody .th:last-child {
		border: none !important;
	}

	.tBody .th .data {
		font-size: 16px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
		width: 167px;
		text-align: center;
	}

	.section .QR {
		width: 1007px;
		height: 114px;
		padding: 0 24px;
		box-sizing: border-box;
		background: #EBF8F1;
		border: 1px solid #BB2916;
		margin-left: 60px;
		font-size: 14px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 24px;
		border-radius: 6px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.section .QR .status {
		font-size: 18px;
		font-family: PingFang SC-Regular, PingFang SC;
		font-weight: 400;
		color: #000000;
		margin-bottom: 10px;
	}

	.QR .status img {
		width: 34px;
		height: 34px;
		margin-right: 8px;
	}

	.section .paymode {
		padding: 0 60px;
		box-sizing: border-box;
		width: 100%;
		margin-bottom: 24px;
	}

	.section .paymode .item {
		margin-right: 16px;
		color: #000000;
		font-size: 14px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 600;
	}

	.section .paymode .item img {
		width: 48px;
		height: 48px;
		margin-right: 14px;
	}
    .section .detail{
		margin-left: 60px;
		margin: 24px 0;
	}
	.line {
		width: 1038px;
		height: 6px;
		margin: 24px 0;
		margin-left: 60px;
	}

	.btnbox {
		justify-content: center;
	}

	.btnbox div {
		width: 324px;
		height: 60px;
		font-size: 22px;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		text-align: center;
		line-height: 60px;
		border-radius: 30px;
	}

	.btnbox .backbtn {
		color: #3A6E61;
		background: #FFFFFF;
		border: 1px solid #3A6E61;
		margin-right: 32px;
	}

	.btnbox .prevbtn {
		color: #FFFFFF;
		background: #BB2916;
	}
</style>